import { Button, Select, message} from 'antd'
import styles from './index.module.scss'
import API from '@api/api.js';
import { useContext, useEffect, useState } from 'react'
import { GenerateContext } from '@utils/GenerateContext'
import eventBus from '@utils/eventBus';

const LeftModelVideo = (props) => {
    const {modelVideoFrontPic, videoResolution,  modelVideo, setModelVideo, modelVideoVersion, setModelVideoVersion} = useContext(GenerateContext)
    const [consumAmount] = useState(80)
    const [loading, setLoading] = useState(false)
    const [videoList, setVideoList] = useState([])
    const [sex, setSex] = useState([])

    const handleClick = async () => {
        eventBus.emit('TOUR_NEXT')
        setLoading(true)
        await props.onCreate()
        eventBus.emit('updatePower')
        setLoading(false)
    }

    useEffect(() => {
        modelvideoList()
    }, [sex])
    

    const modelvideoList = () => {
        API.modelvideoList({
            sex: sex.join()
        }).then(res => {
            if (res.code == 0) {
                setVideoList(res.data)
                setModelVideo(res.data[0]?.name)
                setModelVideoVersion(res.data[0]?.attr.version)
            } else {
                message.warning(res.message)
            }
        })
    }

    const selectVideo = (name, version) => {
        eventBus.emit('TOUR_NEXT')
        setModelVideo(name)
        setModelVideoVersion(version)
    }

    const optFactory = (opt, placeholder) => {
        return {
            mode: "multiple",
            allowClear: true,
            showSearch: false,
            style: {width: '120px'},
            size: 'small',
            maxTagCount: 'responsive',
            placeholder: placeholder,
            options: opt
        }
    }
    const sexOpts = [{
        value: 'female',
        label: '女',
    }, {
        value: 'male',
        label: '男',
    }]
    const tagRender = (props) => {
        const { label } = props;
        return <span className={styles.SelectionTag}>{label}</span>
    }

    return (
        <div className={styles.Container}>
            <div className={styles.Head}>
                <p className={styles.Title}>选择动作</p>
                <div className={styles.VideoSelection}>
                    <Select
                        value={sex}
                        {...optFactory(sexOpts, '性别')}
                        onChange={setSex}
                        tagRender={tagRender}
                    />
                </div>
            </div>
            <div id="tour_target_action" className={styles.video_content}>
            {
                videoList.map((item) => (
                    <div
                        key={item.id}
                        className={modelVideo == item.name ? styles.video_select : null}
                        onClick={() => selectVideo(item.name, item.attr?.version)}
                    >
                    {
                        /.webp$/.test(item.imageUrl) ?
                        <img src={item.imageUrl} /> : 
                        <video
                            src={item.imageUrl}
                            loop
                            muted
                            autoPlay
                            type="video/mp4"
                        ></video>
                    }
                    {
                        item.attr.private === 1 ? <i className={styles.private_icon}></i> : null
                    }
                    </div>
                ))
            }
            </div>
            <div id="tour_target_create" className={styles.GenerateBox}>
                <p className={styles.use_point}>消耗 <img src={require('@assets/images/arcbean2.png')}/><span>{consumAmount}</span></p>
                <Button disabled={!modelVideoFrontPic || !modelVideo} loading={loading} type="primary" onClick={handleClick}>生成</Button>
            </div>
        </div>
    )
}

export default LeftModelVideo